import axios from 'axios';
import * as actionTypes from '../../store/constants/actionTypes';
import * as CookieHelper from '../helpers/CookieHelper';
import store from '../../config/createStore';
import { getStneRefreshedToken } from './salesforceAuthenticator';

const setShouldRefreshToken = (shouldRefreshToken) =>
  store.dispatch({ type: actionTypes.SET_SHOULD_REFRESH_TOKEN, shouldRefreshToken });

axios.interceptors.response.use(
  (response) => response,
  async function (error) {
    const hosts = [
      'stne-salesforce-api-us.azurewebsites.net',
      'stne-workforce-components.azurewebsites.net',
      'stne-salesforce-auth.azurewebsites.net'
    ];

    const tokenHosts = [
      'localhost',
      'api.openbank.stone.com.br/api/v1/stne-salesforce-api',
      'cs-plugin-bff-stg.stone.com.br',
      'cs-plugin-bff-sdx.stone.com.br',
      'cs-plugin-bff-prd.stone.com.br'
    ];

    const completeTokenHosts = [
      'rc-analytics-api.azurewebsites.net',
      'api.openbank.stone.com.br/api/v1/rc-analytics-api',
      'rc-demands-api.azurewebsites.net',
      'api.openbank.stone.com.br/api/v1/rc-demands-api',
      'rc-workforce-api.azurewebsites.net',
      'api.openbank.stone.com.br/api/v1/rc-workforce-api',
      'api.openbank.stone.com.br/api/v1/workforce-manager',
      'rc-plugin-socket.azurewebsites.net'
    ];

    const reqHost = error.config.url;

    if (
      error.response &&
      error.config.url.includes('/oauth/salesforce/refresh') &&
      [400, 401, 500].includes(error.response.status)
    ) {
      CookieHelper.removeCookie('rfTk');
      CookieHelper.removeCookie('new_ssid');
      CookieHelper.removeCookie('userId');
      setShouldRefreshToken(true);
      return Promise.reject(error);
    }

    if (
      error.response &&
      error.response.status === 401 &&
      [...hosts, ...tokenHosts, ...completeTokenHosts].some((partialListedDomain) =>
        reqHost.includes(partialListedDomain)
      )
    ) {
      try {
        await getStneRefreshedToken();

        setShouldRefreshToken(true);

        if (hosts.some((partialListedDomain) => reqHost.includes(partialListedDomain))) {
          error.config.headers = {
            ...error.config.headers,
            sessionId: CookieHelper.getCookie('new_ssid')
          };
        }
        if (tokenHosts.some((partialListedDomain) => reqHost.includes(partialListedDomain))) {
          error.config.headers = {
            ...error.config.headers,
            token: CookieHelper.getCookie('new_ssid')
          };
        }
        if (
          completeTokenHosts.some((partialListedDomain) => reqHost.includes(partialListedDomain))
        ) {
          error.config.headers = {
            ...error.config.headers,
            token: `refreshing_token;${CookieHelper.getCookie('new_ssid')}`
          };
        }

        return axios.request(error.config);
      } catch (err) {
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export const runGetRequest = (url, params, headers, responseType, timeout) => {
  return new Promise((resolve, reject) => {
    axios.defaults.withCredentials = false;

    axios
      .get(url, { params, headers, responseType, timeout })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        if (err?.response?.status === 408) {
          reject({ errorMessage: err.response.data?.message });
        } else {
          reject(err);
        }
      });
  });
};

export const runPostRequest = (url, body, headers, params, responseType) => {
  return new Promise((resolve, reject) => {
    axios.defaults.withCredentials = false;

    axios
      .post(url, body, { params, headers, responseType })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const runPatchRequest = (url, body, headers, params) => {
  return new Promise((resolve, reject) => {
    axios.defaults.withCredentials = false;

    axios
      .patch(url, body, { params, headers })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const runPostRequestErrorTreatment = (url, body, headers, params) => {
  return new Promise((resolve, reject) => {
    axios.defaults.withCredentials = false;

    axios
      .post(url, body, { params, headers })
      .then((res) => {
        resolve({ success: true, response: body });
      })
      .catch((err) => {
        resolve({ success: false, response: body });
      });
  });
};

export const runPutRequest = (url, body, headers, params) => {
  return new Promise((resolve, reject) => {
    axios.defaults.withCredentials = false;

    axios
      .put(url, body, { params, headers })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
